var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        width: "100%",
        height: "100%",
        viewBox: "0 0 47 47",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("rect", {
        attrs: {
          width: "46",
          height: "46",
          transform: "translate(0.441406 0.914062)",
          fill: "white",
        },
      }),
      _c(
        "mask",
        {
          staticStyle: { "mask-type": "alpha" },
          attrs: {
            id: "mask0_906_9040",
            maskUnits: "userSpaceOnUse",
            x: "0",
            y: "0",
            width: "47",
            height: "47",
          },
        },
        [
          _c("rect", {
            attrs: {
              x: "0.441406",
              y: "0.914062",
              width: "46",
              height: "46",
              rx: "6",
              fill: "#C4C4C4",
            },
          }),
        ]
      ),
      _c("g", { attrs: { mask: "url(#mask0_906_9040)" } }, [
        _c("path", {
          attrs: {
            d: "M46.2194 1.13672H0.441406V46.9145H46.2194V1.13672Z",
            fill: "#E53C6A",
          },
        }),
        _c("path", {
          attrs: {
            d: "M0.441406 14.9128V0.914062H46.4414V46.6919H32.3747C14.7385 46.6919 0.441406 32.4639 0.441406 14.9128Z",
            fill: "#FF567B",
          },
        }),
        _c("path", {
          attrs: {
            d: "M46.2196 23.3956V0.914062H24.3555C27.1693 11.7236 35.5326 20.2865 46.2196 23.3956Z",
            fill: "#E53C6A",
          },
        }),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }